import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Finder = (props) => (
  <Icon viewBox="-13.7 17.9 16.2 16.7" {...props}>
    <g>
      <path d="M2.5 34l-3.9-4.3C-.3 28.5.3 26.8.3 25.1c0-3.9-3.1-7.1-7-7.1s-7 3.2-7 7.1 3.1 7.1 7 7.1c1.8 0 3.3-.7 4.6-1.7l3.9 4.3.7-.8zm-15.2-9c0-3.4 2.7-6.1 6-6.1s6 2.7 6 6.1c0 3.4-2.7 6.1-6 6.1s-6-2.8-6-6.1z"
        className="st0" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Finder;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Finder.js